import { atom } from 'jotai';

const showTourAtom = atom(false);

export { showTourAtom };
